import {
  CSSProperties,
  CircularProgress,
  SearchIcon,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@forgeglobal/design-framework'
import { StyleDefaults } from 'isolated-design-library'
import { StylesConfig } from 'react-select/lib/styles'
import { ZIndex } from 'util/ZIndex'
import { components } from 'react-select'
import { useHotkeys } from 'react-hotkeys-hook'
import AsyncSelect, { Async, Props } from 'react-select/lib/Async'
import React, { useRef } from 'react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    placeholder: {
      position: 'absolute',
      left: 40,
      pointerEvents: 'none',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      maxWidth: 'calc(100% - 40px)', // the size of the search icon
    },
    inputStyles: {
      width: '100%',
      '& > input': {
        width: '100% !important',
      },
    },
  })
)

const Placeholder = ({ children }: any) => {
  const classes = useStyles()
  return (
    <Typography variant="body1" color="textSecondary" className={classes.placeholder} fontWeight="light">
      {children}
    </Typography>
  )
}
const LoadingIndicator = (props: any) => (
  <CircularProgress
    size={20}
    variant="indeterminate"
    thickness={4}
    disableShrink={true}
    color="secondary"
    style={{ marginRight: 16 }}
  />
)

const Input = (props: any) => {
  const classes = useStyles()
  return (
    <div style={{ flexGrow: 1 }}>
      <components.Input className={classes.inputStyles} {...props} />
    </div>
  )
}

const ValueContainer = ({ children, ...props }: any) =>
  components.ValueContainer && (
    <components.ValueContainer {...props}>
      {!!children && <SearchIcon style={{ color: StyleDefaults.color.light, fontSize: 24 }} />}
      {children}
    </components.ValueContainer>
  )

export const OmniSearch = ({ style: customStyle, ...rest }: Props<any> & { style?: CSSProperties }) => {
  const selectRef = useRef<Async<any> | null>(null)

  useHotkeys('/', (event: KeyboardEvent) => {
    event.preventDefault()
    selectRef.current && selectRef.current.focus()
  })

  const finalStyles: StylesConfig = {
    menuPortal: styles => ({ ...styles, zIndex: ZIndex.OmniSearch }),
    menuList: () => ({ paddingBottom: '25px', zIndex: ZIndex.OmniSearch }),
    option: (styles, { data }) => ({
      ...styles,
      display: data === 'empty' ? 'none' : 'inherit',
    }),
  }

  return (
    <AsyncSelect
      ref={selectRef}
      placeholder={'Search for accounts and issuers...'}
      styles={finalStyles}
      isClearable={true}
      controlShouldRenderValue={false}
      escapeClearsValue={true}
      components={{
        DropdownIndicator: null,
        Placeholder,
        LoadingIndicator,
        ValueContainer,
        Input,
      }}
      noOptionsMessage={({ inputValue }) => (inputValue.length > 0 ? 'No results found' : null)}
      menuPortalTarget={document.body}
      {...rest}
    />
  )
}
